import { type IssueFieldQuestionMap } from "services/issues/issuesStore";

export enum DirectorAbnQuestion {
  Intro = "DIRECTOR_INTRO",
  Name = "DIRECTOR_NAME",
  Birthday = "DIRECTOR_BIRTHDAY",
  Address = "DIRECTOR_ADDRESS",
  TaxFileNumber = "DIRECTOR_TAX_FILE_NUMBER",
}

export const DIRECTOR_FIELD_TO_QUESTION: IssueFieldQuestionMap<DirectorAbnQuestion> = {
  dob: DirectorAbnQuestion.Birthday,
  first_name: DirectorAbnQuestion.Name,
  middle_names: DirectorAbnQuestion.Name,
  last_name: DirectorAbnQuestion.Name,
  address: DirectorAbnQuestion.Address,
  service_address: DirectorAbnQuestion.Address,
};

export const DIRECTOR_FIELD_TO_PATH: Record<DirectorAbnQuestion, string> = {
  [DirectorAbnQuestion.Intro]: "intro",
  [DirectorAbnQuestion.Name]: "name",
  [DirectorAbnQuestion.Birthday]: "birthday",
  [DirectorAbnQuestion.Address]: "address",
  [DirectorAbnQuestion.TaxFileNumber]: "tfn",
};
